import { render, staticRenderFns } from "./BackToPersonList.vue?vue&type=template&id=5c2cba9d"
import script from "./BackToPersonList.vue?vue&type=script&lang=js"
export * from "./BackToPersonList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports